// ============================================
// Badge Component
// ============================================

import { cn, stageLabels, stageColors, projectLabels, projectColors } from '../lib/utils';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'blue' | 'amber' | 'green' | 'red' | 'purple' | 'gray';
  className?: string;
}

const variants = {
  blue: 'badge-blue',
  amber: 'badge-amber',
  green: 'badge-green',
  red: 'badge-red',
  purple: 'badge-purple',
  gray: 'badge-gray',
};

export function Badge({ children, variant = 'gray', className }: BadgeProps) {
  return (
    <span className={cn(variants[variant], className)}>
      {children}
    </span>
  );
}

// Stage badge
interface StageBadgeProps {
  stage: string;
  className?: string;
}

export function StageBadge({ stage, className }: StageBadgeProps) {
  const label = stageLabels[stage] || stage;
  const colorClass = stageColors[stage] || 'badge-gray';
  
  return (
    <span className={cn(colorClass, className)}>
      {label}
    </span>
  );
}

// Project badge
interface ProjectBadgeProps {
  projectId: string;
  className?: string;
}

export function ProjectBadge({ projectId, className }: ProjectBadgeProps) {
  const label = projectLabels[projectId] || projectId;
  const colorClass = projectColors[projectId] || 'text-slate-400';
  
  return (
    <span className={cn('text-xs font-medium', colorClass, className)}>
      {label}
    </span>
  );
}

// Status dot
interface StatusDotProps {
  status: 'online' | 'offline' | 'busy' | 'away';
  className?: string;
}

const statusColors = {
  online: 'bg-green-500',
  offline: 'bg-slate-500',
  busy: 'bg-red-500',
  away: 'bg-amber-500',
};

export function StatusDot({ status, className }: StatusDotProps) {
  return (
    <span className={cn(
      'inline-block w-2 h-2 rounded-full',
      statusColors[status],
      className
    )} />
  );
}
